export const formatJobData = (data: {
  jobs: {
    absolute_url: string;
    departments: { name: string }[];
    location: { name: string };
    title: string;
  }[];
}) => {
  const { jobs } = data;

  const departmentsSet = Array.from(
    new Set(jobs.map((job) => job.departments[0].name))
  ).sort((a, b) => a.localeCompare(b));

  const openings = departmentsSet.map((department) => ({
    area: department,
    jobs: jobs
      .filter(({ departments }) => departments[0].name === department)
      .map(({ title, location, absolute_url }) => ({
        title,
        location: location.name,
        postUrl: absolute_url
      }))
  }));

  return openings;
};
